<template>
  <div>
    <transactions-in-table
      :transactions="transactions"
      :show-business="showBusiness"
      :show-subscription="showSubscription"
    />
    <pagination
      :resource="pagination"
      :overwrite-path="overwritePath"
      @load="$emit('load', $event)"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import TransactionsInTable from './TransactionsInTable.vue';

export default {
  name: 'TransactionsWithPagination',
  components: {
    Pagination,
    TransactionsInTable,
  },
  props: {
    transactions: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    overwritePath: {
      type: String,
      default: null,
    },
    showBusiness: {
      type: Boolean,
      default: true,
    },
    showSubscription: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
